export enum ProfileStatus {
    Active = 'Active status',
    PendingCancel = 'Pending cancel status',
    Cancelled = 'Cancelled status',
    Deidentified = 'Deidentified status'
}
